export default __webpack_public_path__ + "static/attendees-poster-creation-022994498270239530729f2a7b7fcb92.png";